import {makeEnumTypeGuard} from '../../../../core/src/models/api/types/enumTypes';
import {
  isTextAccentShade,
  resolveAccentShade,
  TextAccentShade,
} from '../../theme/semantic/accentSemanticStyles';
import {ThemeContextReader} from '../../theme/userThemeProvider';

export enum TypographyVariant {
  /** Title */
  TITLE_SEMIBOLD = 'title-semibold',
  TITLE_BOLD = 'title-bold',

  /** Title Small */
  TITLE_SMALL_SEMIBOLD = 'title-small-semibold',
  TITLE_SMALL_BOLD = 'title-small-bold',

  SUBTITLE = 'subtitle',

  SUBTITLE_SMALL = 'subtitle-small',
  SUBTITLE_SMALL_BOLD = 'subtitle-small-bold',
  SUBTITLE_SMALL_BOLDER = 'subtitle-small-bolder',

  BODY = 'body',
  BODY_BOLD = 'body-bold',
  BODY_BOLDER = 'body-bolder',
  BODY_BOLDEST = 'body-boldest',

  BODY_SMALL = 'body-small',
  BODY_SMALL_BOLD = 'body-small-bold',
  BODY_SMALL_BOLDER = 'body-small-bolder',
  BODY_SMALL_BOLDEST = 'body-small-boldest',

  CAPTION = 'caption',
  CAPTION_BOLD = 'caption-bold',
  CAPTION_BOLDER = 'caption-bolder',

  CAPTION_SMALL = 'caption-small',
  CAPTION_SMALL_BOLD = 'caption-small-bold',

  DISPLAY = 'display',
  CODE = 'code',
}

export enum MobileTypographyVariant {
  TITLE = 'title',
  TITLE_BOLD = 'title-bold',
  TITLE_SMALL_BOLD = 'title-small-bold',
  TITLE_SMALL = 'title-small',
  SUBTITLE = 'subtitle',
  SUBTITLE_BOLD = 'subtitle-bold',
  SUBTITLE_BOLDER = 'subtitle-bolder',
  SUBTITLE_BOLDEST = 'subtitle-boldest',
  SUBTITLE_SMALL = 'subtitle-small',
  SUBTITLE_SMALL_BOLD = 'subtitle-small-bold',
  SUBTITLE_SMALL_BOLDER = 'subtitle-small-bolder',
  BODY = 'body',
  BODY_BOLD = 'body-bold',
  BODY_BOLDER = 'body-bolder',
  BODY_BOLDEST = 'body-boldest',
  BODY_SMALL = 'body-small',
  BODY_SMALL_BOLD = 'body-small-bold',
  BODY_SMALL_BOLDER = 'body-small-bolder',
  BODY_SMALL_BOLDEST = 'body-small-boldest',
  CAPTION = 'caption',
  CAPTION_BOLD = 'caption-bold',
  CAPTION_BOLDER = 'caption-bolder',
  CAPTION_SMALL = 'caption-small',
  CAPTION_SMALL_BOLD = 'caption-small-bold',
}

export enum TypographyShade {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',

  DISABLED = 'disabled',

  INVERSE = 'inverse',
  INVERSE_SECONDARY = 'inverse-secondary',

  ON_BG_FILL = 'on-bg-fill',
  ON_BG_FILL_INVERSE = 'on-bg-fill-inverse',
  ON_BG_FILL_DISABLED = 'on-bg-fill-disabled',

  INTERACTIVE = 'interactive',
  INTERACTIVE_HOVER = 'interactive-hover',

  LINK = 'link',
  LINK_HOVER = 'link-hover',

  DANGER = 'danger',
  WARNING = 'warning',
  SUCCESS = 'success',
  BRAND = 'brand',
  CODE = 'code',

  TEXT_SELECTED = 'text-selected',
  TEXT_UNSELECTED = 'text-unselected',
  TEXT_HOVER = 'text-hover',
}

export const isTypographyShade = makeEnumTypeGuard(TypographyShade);

export type TypographyColor = `${TypographyShade}` | TextAccentShade;

/*
 * Helpers.
 */

export function resolveTypographyColor(color: TypographyColor): ThemeContextReader {
  if (isTextAccentShade(color)) {
    const {paletteColor, variant} = resolveAccentShade(color);
    return ({theme}) => theme.accent[paletteColor][variant];
  }

  return ({theme}) => theme.typography.shades[color];
}
